export enum ModifyQuoteType {
  Edit = 'edit',
  Remove = 'remove',
  RemoveExtra = 'extra',
}
